<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="true">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">注文単位値引クーポン登録</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div class="element-column">
          <div>
            <h2>基本情報</h2>
            <div class="element-column">
              <div class="column-list">
                <label class="list-input-title">クーポン種別</label>
                <div class="list-input-content">
                  <app-code-combo-box id="cmb_CouponCategory" #cmb_CouponCategory [style.width.rem]="17"
                    [required]="true" [codeDiv]="'ctp213'" [labelField]="'codeValueName'" [forcedEnabledMode]="'none'"
                    [tabindex]="0" [(ngModel)]="model.couponCategory" (change)="eventChangeHandler_CouponCategory()"
                    [disabled]="isCouponCategory05">
                  </app-code-combo-box>
                </div>
              </div>
              <div class="block-row">
                <div class="column-list">
                  <label class="list-input-title">クーポン注文コード</label>
                  <div class="list-input-content"  [style.width.rem]="8">
                    <input type="text" id="txti_CouponOrderCd" #txti_CouponOrderCd forcedEnabledMode=""
                      [(ngModel)]="model.couponOrderCd" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="6" 
                      [disabled]="isCouponCategory05"/>
                  </div>
                  <label class="list-input-title">通知有無区分</label>
                  <div class="list-input-content">
                    <app-code-combo-box id="cmb_NoticeExistenceType" #cmb_NoticeExistenceType
                      [required]="true" [codeDiv]="'ctp214'" [labelField]="'codeValueName'"
                      [forcedEnabledMode]="'none'" [tabindex]="0" [(ngModel)]="model.noticeExistenceType"
                      (change)="eventChangeHandler_NoticeExistenceType()" [disabled]="isCouponCategory05">
                    </app-code-combo-box>
                  </div>
                </div>
                <div class="column-list">
                  <label class="list-input-title">グループ</label>
                  <div class="list-input-content">
                    <app-code-combo-box id="cmb_CpgrpCd" #cmb_CpgrpCd [style.width.rem]="15"
                      [required]="true" [codeDiv]="'ctp218'" [labelField]="'codeValueName'"
                      [forcedEnabledMode]="'none'" [tabindex]="0" [(ngModel)]="model.cpgrpCd" [disabled]="isCouponCategory05">
                    </app-code-combo-box>
                  </div>
                  <label class="list-input-title">通知方法</label>
                  <div class="list-input-content">
                    <app-checkbox-label label="お届け明細" id="chb_TypeItem" #chb_TypeItem [subid]="'chb_TypeItem'"
                      [(ngModel)]="model.typeItem" (change)="eventChangeHandler_TypeItem()"
                      [disabled]="isCouponCategory05"></app-checkbox-label>
                    <app-checkbox-label label="メルマガ" id="chb_TypeMail" #chb_TypeMail [subid]="'chb_TypeMail'"
                      [(ngModel)]="model.typeMail" [disabled]="isCouponCategory05"></app-checkbox-label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div>
          <h2>利用条件</h2>
          <div class="column-list">
            <label class="list-input-title">利用基準金額</label>
            <div class="list-input-content">
              <input type="text" id="txti_UseStandardPrice" #txti_UseStandardPrice plessInputTextSub
              [(ngModel)]="model.useStandardPrice" [restrict]="'[0-9]'" [maxlength]="7" [style.width.rem]="7"
              (change)="eventChangeHandler_UseStandardPrice()" forcedEnabledMode="" [disabled]="isCouponCategory05"/>
              <span>円以上</span>
            </div>
          </div>
        </div>

        <div>
          <h2>抽出条件</h2>
          <div class="column-list">
            <label class="list-input-title">加入週数</label>
            <div class="list-input-content">
              <input type="text" id="txti_StartMemberWeek" #txti_StartMemberWeek [(ngModel)]="model.startMemberWeek"
                plessInputTextSub [restrict]="'[0-9]'" [maxlength]="2" [style.width.rem]="3" forcedEnabledMode=""
                [disabled]="isCouponCategory05"/>
              <label>～</label>
              <input type="text" id="txti_EndMemberWeek" #txti_EndMemberWeek [(ngModel)]="model.endMemberWeek"
                plessInputTextSub [restrict]="'[0-9]'" [maxlength]="2" [style.width.rem]="3" forcedEnabledMode=""
                [disabled]="isCouponCategory05"/>
            </div>
          </div>
        </div>

        <div>
          <h2>値引情報</h2>
          <div class="element-column">
            <div class="block-row">
              <div class="column-list">
                <label class="list-input-title">クーポン発行期間</label>
                <div class="list-input-content">
                  <app-not-null-text-input type="text" id="txti_CouponIssueCatalogStart" #txti_CouponIssueCatalogStart
                    [(ngModel)]="model.couponIssueCatalogStart" plessInputTextSub [restrict]="'[0-9]'" [maxChars]="8"
                    [style.width.rem]="7" [displayCountField]="false" (change)="eventChangeHandler_CouponIssueCatalogStart()"
                    [disabled]="isCouponCategory05">
                  </app-not-null-text-input>
                  <label>～</label>
                  <app-not-null-text-input type="text" id="txti_CouponIssueCatalogEnd" #txti_CouponIssueCatalogEnd
                    [(ngModel)]="model.couponIssueCatalogEnd" plessInputTextSub [restrict]="'[0-9]'" [maxChars]="8"
                    [style.width.rem]="7" [displayCountField]="false" (change)="eventChangeHandler_CouponIssueCatalogEnd()"
                    [disabled]="isCouponCategory05">
                  </app-not-null-text-input>
                </div>
                <label class="list-input-title">受付期間</label>
                <div class="list-input-content">
                  <input type="text" id="txti_CouponReceiptCatalogStart" #txti_CouponReceiptCatalogStart readonly
                    plessInputTextSub [restrict]="'[0-9]'" [maxlength]="8" [(ngModel)]="model.couponReceiptCatalogStart"
                    [style.width.rem]="7"/>
                  <label>～</label>
                  <input type="text" id="txti_CouponReceiptCatalogEnd" #txti_CouponReceiptCatalogEnd readonly
                    plessInputTextSub [restrict]="'[0-9]'" [maxlength]="8" [(ngModel)]="model.couponReceiptCatalogEnd"
                    [style.width.rem]="7"/>
                </div>
              </div>
              <div class="column-list">
                <label class="list-input-title">有効週</label>
                <div class="list-input-content">
                  <app-not-null-text-input id="txti_ValidWeek" #txti_ValidWeek
                    [restrict]="'[0-9]'" [disabled]="false" [width]="'3rem'" [maxChars]="2"
                    [displayCountField]="false" [(ngModel)]="model.validWeek" [required]="true"
                    (change)="eventChangeHandler_ValidWeek()" [disabled]="isCouponCategory05"></app-not-null-text-input>
                </div>
                <label class="list-input-title">値引単価</label>
                <div class="list-input-content">
                  <app-not-null-text-input id="txti_DiscountPrice" #txti_DiscountPrice  
                    [restrict]="'[0-9]'" [disabled]="false" [style.width.rem]="7" [maxChars]="7"
                    [displayCountField]="false" [(ngModel)]="model.discountPrice"
                    (change)="eventChangeHandler_DiscountPrice()" [disabled]="isCouponCategory05">
                  </app-not-null-text-input>
                </div>
              </div>
            </div>

            <div class="column-list">
              <label class="list-input-title">クーポン名</label>
              <div class="list-input-content">
                <app-not-null-text-input-coop-deli id="txti_CouponName" #txti_CouponName
                  [(ngModel)]="model.couponName" [restrict]="'[ -￮]'" [maxChars]="15" [fullOnly]="true"
                  [displayCountField]="false" [width]="'17rem'" [tabindex]="0" [disabled]="isCouponCategory05">
                </app-not-null-text-input-coop-deli>
              </div>
              <label class="list-input-title">クーポン名(ｶﾅ)</label>
              <div class="list-input-content">
                <app-not-null-text-input id="txti_CouponNameKana" #txti_CouponNameKana
                  [(ngModel)]="model.couponNameKana" [restrict]="'[ -￮]'" [maxChars]="15" [halfOnly]="true"
                  [displayCountField]="false" [width]="'12rem'" [tabindex]="0" [disabled]="isCouponCategory05"
                  (input)="eventCouponNameKana_deleteCommaHandler()"
                  (compositionstart)="onCompStart()" (compositionend)="onCompDeleteCommaEnd($event)">
                </app-not-null-text-input>
              </div>
            </div>
          </div>
        </div>

        <div>
          <h2>利用生協</h2>
          <div class="column-list">
            <label class="list-input-title">利用生協</label>
            <div class="list-input-content">
              <app-checkbox-label label="ALL" id="chk_AllCoop" #chk_AllCoop [subid]="'chk_AllCoop'" [forcedEnabledMode]="'none'"
                [(ngModel)]="model.allCoop" (change)="eventChangeHandler_AllCoop()" [disabled]="isCouponCategory05">
              </app-checkbox-label>
              <app-checkbox-label label="い" id="chk_Ibaraki" #chk_Ibaraki [subid]="'chk_Ibaraki'" [forcedEnabledMode]="'none'"
                [(ngModel)]="model.ibaraki" (change)="eventChangeHandler_CoopCode()" [disabled]="isCouponCategory05">
              </app-checkbox-label>
              <app-checkbox-label label="と" id="chk_Tochigi" #chk_Tochigi [subid]="'chk_Tochigi'" [forcedEnabledMode]="'none'"
                [(ngModel)]="model.tochigi" (change)="eventChangeHandler_CoopCode()" [disabled]="isCouponCategory05">
              </app-checkbox-label>
              <app-checkbox-label label="ぐ" id="chk_Gunma" #chk_Gunma [subid]="'chk_Gunma'" [forcedEnabledMode]="'none'"
                [(ngModel)]="model.gunma" (change)="eventChangeHandler_CoopCode()" [disabled]="isCouponCategory05">
              </app-checkbox-label>
              <app-checkbox-label label="ち" id="chk_Chiba" #chk_Chiba [subid]="'chk_Chiba'" [forcedEnabledMode]="'none'"
                [(ngModel)]="model.chiba" (change)="eventChangeHandler_CoopCode()" [disabled]="isCouponCategory05">
              </app-checkbox-label>
              <app-checkbox-label label="さ" id="chk_Saitama" #chk_Saitama [subid]="'chk_Saitama'" [forcedEnabledMode]="'none'"
                [(ngModel)]="model.saitama" (change)="eventChangeHandler_CoopCode()" [disabled]="isCouponCategory05">
              </app-checkbox-label>
              <app-checkbox-label label="とう" id="chk_Tokyo" #chk_Tokyo [subid]="'chk_Tokyo'" [forcedEnabledMode]="'none'"
                [(ngModel)]="model.tokyo" (change)="eventChangeHandler_CoopCode()" [disabled]="isCouponCategory05">
              </app-checkbox-label>
              <app-checkbox-label label="な" id="chk_Nagano" #chk_Nagano [subid]="'chk_Nagano'" [forcedEnabledMode]="'none'"
                [(ngModel)]="model.nagano" (change)="eventChangeHandler_CoopCode()" [disabled]="isCouponCategory05">
              </app-checkbox-label>
              <app-checkbox-label label="に" id="chk_Niigata" #chk_Niigata [subid]="'chk_Niigata'" [forcedEnabledMode]="'none'"
                [(ngModel)]="model.niigata" (change)="eventChangeHandler_CoopCode()" [disabled]="isCouponCategory05">
              </app-checkbox-label>
            </div>
          </div>
        </div>

        <div>
          <h2>メッセージ内容</h2>
          <div class="column-list">
            <label class="list-input-title">タイトル(EC)</label>
            <div class="list-input-content">
              <app-not-null-text-input-coop-deli id="txti_EcTitle" #txti_EcTitle [restrict]="'[ -￮]'" [maxChars]="24" [fullOnly]="true"
                [displayCountField]="false"[(ngModel)]="model.ecTitle" [style.width.rem]="30"
                (change)="eventChangeHandler_EcTitle()" [disabled]="isCouponCategory05">
              </app-not-null-text-input-coop-deli>
            </div>
            <label class="list-input-title">タイトル(お届け明細)</label>
            <div class="list-input-content">
              <input type="text" id="txti_DetailsTitle" #txti_DetailsTitle readonly
                plessInputTextSub [(ngModel)]="model.detailsTitle" [style.width.rem]="30"/>
            </div>
            <label class="list-input-title">利用条件</label>
            <div class="list-input-content">
              <input type="text" id="txti_UseTerms" #txti_UseTerms plessInputTextSub
                [maxlength]="26" [(ngModel)]="model.useTerms" [style.width.rem]="30" readonly/>
            </div>
            <label class="list-input-title">値引き額</label>
            <div class="list-input-content">
              <input type="text" id="txti_DiscountedAmount" #txti_DiscountedAmount plessInputTextSub
                [maxlength]="16" [(ngModel)]="model.discountedAmount" [style.width.rem]="20" readonly/>
            </div>
            <label class="list-input-title">有効期限</label>
            <div class="list-input-content">
              <input type="text" id="txti_ValidatedDate" #txti_ValidatedDate plessInputTextSub
                [maxlength]="18" [(ngModel)]="model.validatedDate" [style.width.rem]="20" readonly/>
            </div>
          </div>
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button class="btn-primary" id="btn_Entry" #btn_Entry (click)="eventEntry_CLICKHandler()" forcedEnabledMode=""
            [tabindex]="0" [disabled]="isCouponCategory05">登録</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button id="btn-close" [tabindex]="0" (click)="onClickWindowClose()" forcedEnabledMode="true"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>